<div class="container text-center">
  <div class="wrapper">
    <mat-icon class="spin loading-icon">autorenew</mat-icon>
    <br><br>
    <h1 class="lead">Signing in ....</h1>
  </div>
</div>